<template>
    <div>
        <el-form :model="chargeItemInfo" :rules="chargeItemRules" ref="chargeItemInfo">
            <div class="form-info">
                <div class="form-row">
                    <div class="form-label">
                        <label class="required">名称：</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="name">
                            <el-input v-model="chargeItemInfo.name"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-label">
                        <label class="required">参考价格(元)：</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="price">
                            <el-input type="number" v-model="chargeItemInfo.price"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'

    import servcOperApi from '../../api/servcOper'

    export default {
        name: 'swb-servc-type-charge-item-save',
        desc: '服务参考价格',
        props: ['id'],
        data: function () {
            let checkName = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('名称不可为空'));
                } else {
                    callback();
                }
            };
            let checkPrice = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('价格不可为空'));
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                chargeItemInfo: {},
                chargeItemRules: {
                    name: [{validator: checkName, trigger: 'blur'}],
                    price: [{validator: checkPrice, trigger: 'blur'}],
                }
            }
        },
        created(){
            if(!Utils.isNoB(this.id)) {
                this.getChargeItemInfo(this.id);
            }
        },
        methods: {
            getChargeItemInfo: function (id) {
                let self = this;
                servcOperApi.getServcTypeChargeItem(id, function (result) {
                    if(result.type == 'info') {
                        self.chargeItemInfo = result.data || {};
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['chargeItemInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        result.data = self.chargeItemInfo;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            },
        },
    }
</script>




// WEBPACK FOOTER //
// src/compo/categ/ServcTypeChargeItemSave.vue